import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { round } from 'lodash-es';
import { Subscription } from 'rxjs';
import { AndelCombochartBaseComponent } from '../../base-components';
import { Constants } from '../../../common/constants';
import { GoogleCombochartComponent } from '../../../google-charts/google-charts-base-components/google-combochart/google-combochart.component';

@Component({
    selector: 'app-foryngring-mellanmark-andel-tall-chart',
    templateUrl: './foryngring-mellanmark-andel-tall-chart.component.html',
    styleUrls: ['./foryngring-mellanmark-andel-tall-chart.component.scss']
})
export class ForyngringMellanmarkAndelTallChartComponent extends AndelCombochartBaseComponent implements OnInit, OnDestroy {
    @ViewChild(GoogleCombochartComponent, { static: true })
    googleCombochart: GoogleCombochartComponent;

    private subs: Subscription[];
    data: any[][];
    public andelMellanMarker: number = 0;
    public chartName: string = Constants.DIAGRAM_NAMN.TALL_PA_MELLANMARK;

    ngOnInit(): void {
        this.subs = [];
        this.subs.push(
            this.inventeringar$.subscribe((x) => {
                if (x && x.length > 0) {
                    const data: any[][] = [
                        [
                            'År',
                            { id: 'Arsskada_1ar', type: 'number', label: 'Årsvärde' },
                            { id: 'Medelfel_low', type: 'number', role: 'interval' },
                            { id: 'Medelfel_high', type: 'number', role: 'interval' },
                            { id: 'tool_tip_1ar', type: 'string', role: 'tooltip', p: { html: true } },
                            { id: 'Medel_3ar', type: 'number', label: 'Sammanvägning för de tre senaste inventeringarna' },
                            { id: 'Medelfel_3ar_low', type: 'number', role: 'interval' },
                            { id: 'Medelfel_3ar_high', type: 'number', role: 'interval' },
                            { id: 'tool_tip_3ar', type: 'string', role: 'tooltip', p: { html: true } }
                        ]
                    ];
                    x.forEach((inv) => {
                        if (inv.standortsanpassningAndelMellanMarkerMedTall || inv.standortsanpassningAndelMellanMarkerMedTall === 0) {
                            // Uppdatera värdet för mellanmark om det finns för inventeringen
                            if (inv.andelMellanMarker3InvMedel && inv.andelMellanMarker3InvMedel > 0) {
                                this.andelMellanMarker = round(inv.andelMellanMarker3InvMedel * 100, 1);
                            }

                            // Årsskada
                            const arsVarde = round(inv.standortsanpassningAndelMellanMarkerMedTall * 100, 1);
                            const mfelArsvarde = inv.medelfelAndelMellanMarkerMedTall * 100 * 2;
                            const mfel_Arsvarde_low = arsVarde > 0 ? round(arsVarde - mfelArsvarde, 2) : null;
                            const mfel_Arsvarde_high = arsVarde > 0 ? round(arsVarde + mfelArsvarde, 2) : null;

                            // 3års medel
                            const trearsMedel = round(inv.standortsanpassningAndelMellanMarkerMedTall3InvMedel * 100, 1);
                            const mfel3arArsvarde95procent = inv.medelfelAndelMellanMarkerMedTall_3InvMedel * 2 * 100;
                            const mfel3arArsvarde_low = trearsMedel - mfel3arArsvarde95procent;
                            const mfel3arArsvarde_high = trearsMedel + mfel3arArsvarde95procent;

                            data.push([
                                `${inv.invAr}`,
                                arsVarde > 0 ? arsVarde : null,
                                mfel_Arsvarde_low > 0 ? mfel_Arsvarde_low : 0,
                                mfel_Arsvarde_high,
                                this.getTooltip(false, arsVarde, mfelArsvarde, '1.1-1'),
                                trearsMedel,
                                mfel3arArsvarde_low > 0 ? mfel3arArsvarde_low : 0,
                                mfel3arArsvarde_high,
                                this.getTooltip(true, trearsMedel, mfel3arArsvarde95procent, '1.1-1')
                            ]);
                        }
                    });
                    this.options = {
                        ...this.options,
                        tooltip: { isHtml: true },
                        interval: {
                            Medelfel_low: { style: 'bars', lineWidth: 2 },
                            Medelfel_high: { style: 'bars', lineWidth: 2 },
                            Medelfel_3ar_low: { style: 'area', curveType: 'none', fillOpacity: 0.48 },
                            Medelfel_3ar_high: { style: 'area', curveType: 'none', fillOpacity: 0.48 }
                        },
                        height: 250,
                        vAxis: {
                            ...this.options.vAxis,
                            maxValue: this.getMaxValue(data)
                        }
                    };

                    this.data = data;
                }
            })
        );

        this.subs.push(
            this.googleCombochart.chartImg$.subscribe((chartImgObj: { chartName: string; imgUri: string }) => {
                this.chartToImageSvc.setChartImage(chartImgObj);
            })
        );
    }

    ngOnDestroy(): void {
        this.subs.forEach((x) => x.unsubscribe());
    }
}
